import { Component } from '@angular/core';
import { MainBtnComponent } from '../main-btn/main-btn.component';

@Component({
  selector: 'app-cover-static-exam',
  imports: [
    // MainBtnComponent
  ],
  templateUrl: './cover-static-exam.component.html',
  styleUrl: './cover-static-exam.component.css'
})
export class CoverStaticExamComponent {

}
